import { Box } from "@mui/material";
import { type ReactNode } from "react";

/** Shared animation timing for SidePanel components */
export const SIDE_PANEL_TRANSITION_DURATION_MS = 380;
export const SIDE_PANEL_TRANSITION_EASING = "cubic-bezier(0.2, 0.9, 0.3, 1)";
export const SIDE_PANEL_TRANSITION = `${SIDE_PANEL_TRANSITION_DURATION_MS}ms ${SIDE_PANEL_TRANSITION_EASING}`;

interface SidePanelSectionProps {
  anchor: "left" | "right";
  isOpen: boolean;
  width: number;
  children: ReactNode;
}

/** A single panel inside a `SidePanelGroup`: an animated-width column with a leading divider. */
export function SidePanelSection(props: SidePanelSectionProps) {
  const { anchor, isOpen, width, children } = props;
  const dividerSide = anchor === "right" ? "borderLeft" : "borderRight";

  return (
    <Box
      sx={(theme) => ({
        width: isOpen ? width : 0,
        height: "100%",
        flexShrink: 0,
        overflow: "hidden",
        transition: `width ${SIDE_PANEL_TRANSITION}`,
        // Divider between panels (only when open, skip first to avoid double border with container)
        "&:not(:first-of-type)": {
          [dividerSide]: isOpen
            ? `${theme.borderWidth?.regular} solid ${theme.palette.border?.base}`
            : undefined,
        },
      })}
    >
      <Box
        sx={{
          width,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
